import { Loader } from '@components/loader';
import { useGetApiKey } from '@services/acquirer/apiKeys/get';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { ApiKeyShow } from '@pages/apiKeys/id';
import { useDisableApiKey } from '@services/acquirer/apiKeys/disable';
import { useGetPermissionGroups } from '@services/acquirer/apiKeys/permissionGroups';

const ShowApiKey = () => {
  const { id, localId } = useParams({ from: '/u/$localId/_acquirer/acquirer/api-keys/$id/' });
  const navigate = useNavigate();
  const { data, isPending } = useGetApiKey(id);
  const { mutate, isPending: disabling } = useDisableApiKey();
  const { data: permissions } = useGetPermissionGroups();

  if (isPending) return <Loader />;

  return (
    <ApiKeyShow
      apiKey={data}
      onDisable={mutate}
      disabling={disabling}
      permissions={permissions}
      updatePermission="acquirer_api_keys_update"
      disablePermission="acquirer_api_keys_disable"
      createPermission="acquirer_api_keys_create"
      handleDuplicateRedirect={() => {
        navigate({
          to: '/u/$localId/acquirer/api-keys/new',
          params: { localId },
          search: { duplicateFrom: data.id },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/api-keys/$id/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['acquirer_api_keys_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: ShowApiKey,
});
